import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ClientEntity } from './client.entity';
import { WarehouseEntity } from './warehouse.entity';

@Index('fk_client__id', ['fkClientId'], {})
@Index('fk_warehouse__id', ['fkWarehouseId'], {})
@Entity('client_warehouse')
export class ClientWarehouseEntity extends BaseEntity {
	@Column('int', { name: 'fk_client__id', unsigned: true })
	public fkClientId!: number;

	@Column('int', { name: 'fk_warehouse__id', unsigned: true })
	public fkWarehouseId!: number;

	@ManyToOne(() => ClientEntity, (client) => client.clientWarehouses, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_client__id', referencedColumnName: 'id' }])
	public fkClient!: ClientEntity;

	@ManyToOne(() => WarehouseEntity, (warehouse) => warehouse.clientWarehouses, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_warehouse__id', referencedColumnName: 'id' }])
	public fkWarehouse!: WarehouseEntity;
}
